import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useBoolean } from "@/hooks/use-boolean";
import useCreateShopStore from "@babackapp/private-api-client/client/use-create-shop-store";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { PropsWithChildren } from "react";
import StoreForm from "./store-form";
import { StoreFormValues } from "./types";

export default function AddStoreDialog({ children }: PropsWithChildren) {
  const { data: shop } = useCurrentShopSuspense();
  const open = useBoolean(false);
  const t = useTranslation();

  const { mutateAsync: createShopStore } = useCreateShopStore({
    shopId: shop.id,
    onSettled: (_, err) => !err && open.setFalse(),
  });

  const onSubmit = (data: StoreFormValues) => {
    createShopStore({
      name: data.general.address.companyName,
      selectableByUser: data.general.selectableByUser ?? true,
      externalId: data.general.externalId,
      address: {
        address1: data.general.address.address1,
        address2: data.general.address.address2,
        city: data.general.address.city,
        country_code: data.general.address.country.code,
        country_name: data.general.address.country.name,
        zip: data.general.address.zip,
        companyName: data.general.address.companyName,
        country: data.general.address.country.name,
      },
      openingHours: data.openingTimes,
      urlMap: data.general.urlMap,
      embedMap: data.general.embedMap,
    });
  };

  return (
    <Dialog open={open.value} onOpenChange={open.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <p className="text-lg leading-6 text-left font-medium text-gray-900">
          {t("settings.shop.physic.updateStoreTitle")}
        </p>
        <div className="mt-2 ">
          <p className="text-sm text-gray-500">
            {t("settings.shop.physic.addStoreDescription")}
          </p>
        </div>
        <StoreForm onSubmit={onSubmit} />
      </DialogContent>
    </Dialog>
  );
}
